import { Show, createEffect, createSignal } from "solid-js";
import { useAppState } from "@core/state/AppState";

export function SettingsPage() {
  const appState = useAppState();
  const state = appState.snapshot();

  const [displayName, setDisplayName] = createSignal("");
  const [email, setEmail] = createSignal("");
  const [smsOptIn, setSmsOptIn] = createSignal(false);
  const [emailOptIn, setEmailOptIn] = createSignal(false);
  const [pushOptIn, setPushOptIn] = createSignal(true);
  const [isSaving, setIsSaving] = createSignal(false);

  createEffect(() => {
    const profile = state.profile();
    if (!profile) {
      return;
    }
    setDisplayName(profile.displayName ?? "");
    setEmail(profile.email ?? "");
    setSmsOptIn(profile.notificationPrefs?.sms ?? false);
    setEmailOptIn(profile.notificationPrefs?.email ?? false);
    setPushOptIn(profile.notificationPrefs?.push ?? true);
  });

  const handleSubmit = async (event: Event) => {
    event.preventDefault();
    if (isSaving()) return;
    setIsSaving(true);

    // Build profile update object, excluding undefined values
    const profileUpdate: any = {
      notificationPrefs: {
        sms: smsOptIn(),
        email: emailOptIn(),
        push: pushOptIn()
      }
    };

    // Only include displayName if it has a value
    if (displayName().trim()) {
      profileUpdate.displayName = displayName();
    }

    // Only include email if it has a value
    if (email().trim()) {
      profileUpdate.email = email();
    }

    await appState.updateProfile(profileUpdate);
    setIsSaving(false);
  };

  return (
    <div class="main-container">
      <div class="settings-page">
        <h2 class="settings-title">Account Settings</h2>
        <Show when={state.profile()} fallback={<p class="muted">Loading your profile…</p>}>
          <form class="settings-form" onSubmit={handleSubmit}>
          <div class="form-field">
            <label class="input-label" for="settings-name">Display name</label>
            <input
              id="settings-name"
              type="text"
              class="input-control"
              value={displayName()}
              onInput={(event) => setDisplayName(event.currentTarget.value)}
              placeholder="Your name"
            />
          </div>

          <div class="form-field">
            <label class="input-label" for="settings-email">Email</label>
            <input
              id="settings-email"
              type="email"
              class="input-control"
              value={email()}
              onInput={(event) => setEmail(event.currentTarget.value)}
              placeholder="you@example.com"
            />
          </div>

          <fieldset class="settings-notifications">
            <legend class="fieldset-title">Notifications</legend>
            <label class="switch">
              <input type="checkbox" checked={smsOptIn()} onInput={(event) => setSmsOptIn(event.currentTarget.checked)} />
              <span>SMS updates</span>
            </label>
            <label class="switch">
              <input type="checkbox" checked={emailOptIn()} onInput={(event) => setEmailOptIn(event.currentTarget.checked)} />
              <span>Email updates</span>
            </label>
            <label class="switch">
              <input type="checkbox" checked={pushOptIn()} onInput={(event) => setPushOptIn(event.currentTarget.checked)} disabled />
              <span>Push notifications</span>
            </label>
          </fieldset>

            <div class="form-actions">
              <button type="submit" class="btn-primary" disabled={isSaving()}>
                {isSaving() ? "Saving…" : "Save changes"}
              </button>
            </div>
          </form>
        </Show>
      </div>
    </div>
  );
}
